export const EMAIL_REGEX = "^([a-zA-Z0-9_\\.\\-\\+\\'])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$";
